import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { theme } from '@theme/.';
import { environment as env } from '@app/environment';
import { AuthService } from '@app/services';
import { SettingsService } from '@app/services/settings';
import { FormsModule } from '@angular/forms';

@Component({
  styleUrls: ['./patientlynk-outro-modal.component.scss'],
  templateUrl: './patientlynk-outro-modal.component.html',
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'banner',
        loader: {
          en: () => import('./en.json'),
          es: () => import('./es.json'),
        }
      }
    }
  ]
})
export class PatientlynkOutroModalComponent {
  theme = theme;
  popupSettings = this.settings.select('patientLynkOutroPopup');

  constructor(private auth: AuthService, public modal: NgbActiveModal, public settings: SettingsService) {}

  openExternal(): void {
    const refresh = this.auth.store.getValue().refresh;
    document.location.href = env.patientlynk_url + '/login?token=' + refresh;
  }

  onDontShowAgainChange(event) {
    this.settings.update({
      patientLynkOutroPopup: {
        dontShow: event?.target?.checked,
        hasSeen: true,
      }
    });
  }
}

@NgModule({
  declarations: [PatientlynkOutroModalComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    FormsModule
  ],
  exports: [PatientlynkOutroModalComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'banner',
        loader: {
          en: () => import('./en.json'),
          es: () => import('./es.json'),
        }
      }
    }
  ]
})
export class PatientlynkOutroModalComponentModule {
}
